import {Component, HostListener, OnInit} from '@angular/core';
import {FooterService} from '../../../services/footer.service';

@Component({
  selector: 'app-measuring-distance',
  templateUrl: './app-location.component.html',
  styleUrls: ['./app-location.component.css']
})
export class AppLocationComponent implements OnInit {

  footerHeight: number;

  constructor(private footerService: FooterService) { }

  @HostListener('window:resize', ['$event'])
  onResize(event): void {
    setTimeout(() => {
      this.footerHeight = this.footerService.getFooterHeight();
    }, 500);
  }

  ngOnInit(): void {
    this.footerHeight = this.footerService.getFooterHeight();
  }
}
